import { PROPERTY_BLOCKLIST } from 'reporting-snowflake/funnel/constants/properties';

/**
 * This is a temporary pattern to address a property migration for
 * calculated stage properties. For saved reports with these properties, the properties
 * should still load with the report but not have the option to add these properties in new reports.
 * More info - https://community.hubspot.com/t5/Developer-Announcements/Upcoming-Sunset-of-Legacy-Stage-Calculated-Properties-for/m-p/1026312
 */
export const TEMP_PROPERTY_PREFIXES = ['hs_lifecyclestage_', 'hs_date_entered_', 'hs_date_exited_', 'hs_time_in_'];
const isHiddenProperty = ({
  hidden,
  name
}) => !!hidden && TEMP_PROPERTY_PREFIXES.filter(excludedPrefix => name.startsWith(excludedPrefix)).length === 0;
export const isBlocklisted = ({
  name
}) => PROPERTY_BLOCKLIST.includes(name);
export const excludeProperties = (properties, conditions) => {
  const propertyKeys = Object.keys(properties);
  return propertyKeys.reduce((accum, propertyKey) => {
    const sqlProperty = properties[propertyKey];
    const {
      propertyDefinition: {
        property
      }
    } = sqlProperty;
    const shouldExcludeProperty = conditions.some(condition => condition(property));
    return shouldExcludeProperty ? accum : Object.assign({}, accum, {
      [propertyKey]: sqlProperty
    });
  }, {});
};
export const sanitizeProperties = properties => excludeProperties(properties, [isHiddenProperty, isBlocklisted]);
export const __TESTABLE__ = {
  sanitizeProperties
};